import { Card, CardContent } from "@/components/ui/card";

export const KpiCard = ({ label, value, icon: Icon, tone = "primary", testId }) => {
  const tones = {
    primary: "bg-primary/10 text-primary",
    success: "bg-emerald-100 text-emerald-700",
    warning: "bg-amber-100 text-amber-700",
    violet: "bg-violet-100 text-violet-700",
    slate: "bg-slate-100 text-slate-700",
  };
  return (
    <Card className="rounded-xl border-border shadow-none" data-testid={testId}>
      <CardContent className="p-5 flex items-center gap-4">
        <span className={`h-11 w-11 rounded-xl flex items-center justify-center shrink-0 ${tones[tone]}`}>
          {Icon && <Icon className="h-5 w-5" />}
        </span>
        <div className="min-w-0">
          <p className="text-2xl font-heading font-semibold leading-none">{value}</p>
          <p className="text-xs text-muted-foreground mt-1.5 truncate">{label}</p>
        </div>
      </CardContent>
    </Card>
  );
};
